import { Alert, Box, Stack, Tab, Tabs } from "@mui/material";
import { LoadingScreen } from "components/LoadingScreen";
import { DeleteModal } from "components/UI";
import { BasicInformation, Leadership, ProfileHeader } from "features/churches";
import {
  useDeleteDenominationChurch,
  useDenominationChurch
} from "features/denominations";
import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useCentralStore } from "stores";

export function DenominationChurch() {
  const [tabValue, setTabValue] = useState(0);

  const { id: denominationId, churchId } = useParams();
  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);
  const closeDeleteModal = useCentralStore(state => state.closeDeleteModal);
  const setHeaderBackground = useCentralStore(
    state => state.setHeaderBackground
  );
  const churchQuery = useDenominationChurch({
    churchId,
    denominationId
  });
  const churchDeleteMutation = useDeleteDenominationChurch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    setHeaderTitle(t("churches.createChurch.churchProfile"));

    return () => setHeaderTitle("");
  }, [i18next.language]);

  useEffect(() => {
    setHeaderBackground(false);

    return () => setHeaderBackground(true);
  }, []);

  if (churchQuery.isLoading) {
    return <LoadingScreen />;
  }

  if (churchQuery.isError) {
    return (
      <Alert severity="error">
        {t("churches.profile.errorLoadingChurchData")}
      </Alert>
    );
  }

  const church = churchQuery.data?.result;

  const tabContent = {
    0: <BasicInformation church={church} isDenominationChurch />,
    1: <Leadership church={church} isDenominationChurch />
  };

  return (
    <Stack sx={{ gap: "56px" }}>
      <DeleteModal
        title={t("form.common.delete")}
        onDelete={() => {
          churchDeleteMutation.mutate(
            {
              churchId,
              denominationId
            },
            {
              onSuccess: () => {
                closeDeleteModal();
                navigate(`/denomination-dashboard/${denominationId}/churches`, {
                  replace: true
                });
              }
            }
          );
        }}
        name={church?.name}
      />

      {/* Header */}
      <ProfileHeader church={church} isDenominationChurch />

      {/* Tabs */}
      <Box
        sx={{ backgroundColor: "neutral.main", borderRadius: "8px", p: "4px" }}
      >
        <Tabs
          value={tabValue}
          onChange={(event, value) => setTabValue(value)}
          indicatorColor=""
          variant="fullWidth"
        >
          {[
            { label: t("churches.profile.basicInfo"), value: 0 },
            { label: t("churches.profile.leadership"), value: 1 }
          ].map(tab => (
            <Tab
              key={tab.value}
              label={tab.label}
              sx={{
                flex: 1,
                color: "text.primary",
                "&.Mui-selected": {
                  borderRadius: "8px",
                  background: "white",
                  color: "primary.main",
                  boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.08)"
                }
              }}
            />
          ))}
        </Tabs>
      </Box>

      {tabContent[tabValue]}
    </Stack>
  );
}
